import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { MODULE_TYPES } from 'ohif-core';
import OHIF from 'ohif-core';
import moment from 'moment';
import ConnectedCTToolbarRow from './ConnectedCTToolbarRow.js';
import ConnectedViewerMain from './ConnectedViewerMain.js';
import ConnectedStudyLoadingMonitor from './ConnectedStudyLoadingMonitor';
import SidePanel from './../components/SidePanel';
import { extensionManager } from './../App.js';
import './CTViewer.css';
import qs from 'query-string';
// import DicomInfo from '../components/DicomInfo/DicomInfo';
import waiting from '../imgs/waiting.png';

class CTViewer extends Component {
  static propTypes = {
    studies: PropTypes.array,
    studyInstanceUids: PropTypes.array,
    viewports: PropTypes.object.isRequired,
    activeViewportIndex: PropTypes.number.isRequired,
    setViewportSpecificData: PropTypes.func.isRequired,
    onTimepointsUpdated: PropTypes.func,
    onMeasurementsUpdated: PropTypes.func,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    OHIF.measurements.MeasurementApi.setConfiguration({
      dataExchange: {
        retrieve: this.retrieveMeasurements,
        store: this.storeMeasurements,
      },
    });

    OHIF.measurements.TimepointApi.setConfiguration({
      dataExchange: {
        retrieve: this.retrieveTimepoints,
        store: this.storeTimepoints,
        remove: this.removeTimepoint,
        update: this.updateTimepoint,
        disassociate: this.disassociateStudy,
      },
    });

    const search = qs.parse(window.location.search);
    this.state = {
      ...search,
      isLeftSidePanelOpen: true,
      isRightSidePanelOpen: false,
      selectedRightSidePanel: 'charts-panel',
      selectedLeftSidePanel: 'ct-studies-panel', // TODO: Don't hardcode this
      thumbnails: [],
      thumbIndex: 0,
      loading: true,
    };
  }

  retrieveMeasurements = (patientId, timepointIds) => {
    // TODO: Retrieve the measurements from the latest available SR
    return Promise.resolve();
  };

  storeMeasurements = (measurementData, timepointIds) => {
    // TODO: Store the measurements into a new SR sent to the active server
    return Promise.resolve();
  };

  retrieveTimepoints = filter => {
    // Get the earliest and latest study date
    let earliestDate = new Date().toISOString();
    let latestDate = new Date().toISOString();
    if (this.props.studies) {
      latestDate = new Date('1000-01-01').toISOString();
      this.props.studies.forEach(study => {
        const studyDate = moment(study.studyDate, 'YYYYMMDD').toISOString();
        if (studyDate < earliestDate) earliestDate = studyDate;
        if (studyDate > latestDate) latestDate = studyDate;
      });
    }

    // Return a generic timepoint
    return Promise.resolve([
      {
        timepointType: 'baseline',
        timepointId: 'TimepointId',
        studyInstanceUids: this.props.studyInstanceUids,
        patientId: filter.patientId,
        earliestDate,
        latestDate,
        isLocked: false,
      },
    ]);
  };

  storeTimepoints = timepointData => {
    OHIF.log.info('storeTimepoints');
    return Promise.resolve();
  };

  updateTimepoint = (timepointData, query) => {
    OHIF.log.info('updateTimepoint');
    return Promise.resolve();
  };

  removeTimepoint = timepointId => {
    OHIF.log.info('removeTimepoint');
    return Promise.resolve();
  };

  disassociateStudy = (timepointIds, studyInstanceUid) => {
    OHIF.log.info('disassociateStudy');
    return Promise.resolve();
  };

  onTimepointsUpdated = timepoints => {
    if (this.props.onTimepointsUpdated)
      this.props.onTimepointsUpdated(timepoints);
  };

  onMeasurementsUpdated = measurements => {
    if (this.props.onMeasurementsUpdated)
      this.props.onMeasurementsUpdated(measurements);
  };

  componentDidMount() {
    this.setState({ thumbIndex: 0 });
    window.localStorage.setItem('thumbIndex', 0);
  }
  onThumbnailLoaded = item => {
    const { activeViewportIndex } = this.props;

    const study = this.props.studies.find(study => {
      return study.studyInstanceUid === item.studyInstanceUid;
    });
    if (!study) return;

    const displaySet = study.displaySets.find(displaySet => {
      return displaySet.displaySetInstanceUid === item.displaySetInstanceUid;
    });
    this.props.setViewportSpecificData(activeViewportIndex, displaySet);
  };
  onLoadFinished = () => {
    this.setState({ loading: false });
  };
  onThumbnailClick = item => {
    const { activeViewportIndex } = this.props;
    const index = item.thumbIndex;
    window.localStorage.setItem('thumbIndex', index);

    const study = this.props.studies.find(study => {
      return study.studyInstanceUid === item.studyInstanceUid;
    });

    if (!study) return;

    const displaySet = study.displaySets.find(displaySet => {
      return displaySet.displaySetInstanceUid === item.displaySetInstanceUid;
    });
    this.props.setViewportSpecificData(activeViewportIndex, displaySet);
  };

  componentDidUpdate(prevProps) {
    const { studies } = this.props;
    if (studies !== prevProps.studies) {
      this.setState({ thumbnails: _mapStudiesToThumbnails(studies) });
    }
  }

  render() {
    let VisiblePanelLeft, VisiblePanelRight;
    const panelExtensions = extensionManager.modules[MODULE_TYPES.PANEL];
    panelExtensions.forEach(panelExt => {
      panelExt.module.components.forEach(comp => {
        if (comp.id === this.state.selectedRightSidePanel) {
          VisiblePanelRight = comp.component;
        } else if (comp.id === this.state.selectedLeftSidePanel) {
          VisiblePanelLeft = comp.component;
        }
      });
    });
    const { isLeftSidePanelOpen, isRightSidePanelOpen, loading } = this.state;
    return (
      <>
        {/* TOOLBAR */}
        <ConnectedCTToolbarRow extensionId="ai-charts" />
        {/* <DicomInfo user={this.props.user} /> */}
        <ConnectedStudyLoadingMonitor studies={this.props.studies || []} />
        <div className="FlexboxLayout">
          {/* LEFT */}
          <SidePanel from="left" isOpen={isLeftSidePanelOpen}>
            {VisiblePanelLeft && (
              <VisiblePanelLeft
                viewports={this.props.viewports}
                activeIndex={this.props.activeViewportIndex}
                studies={this.state.thumbnails}
                onThumbnailClick={this.onThumbnailClick}
                onThumbnailLoaded={this.onThumbnailLoaded}
                onLoadFinished={this.onLoadFinished}
              />
            )}
          </SidePanel>

          {/* MAIN */}
          <div className="main-content">
            <ConnectedViewerMain studies={this.props.studies} />
            {loading && <div className="image-loading"></div>}
          </div>

          {loading && (
            <div className="img-loading-text">
              <img src={waiting} alt="" />
              <p>图像数据加载中……</p>
            </div>
          )}

          {/* RIGHT */}
          <SidePanel from="right" isOpen={isRightSidePanelOpen}>
            {VisiblePanelRight && <VisiblePanelRight />}
            {loading && <div className="image-loading"></div>}
          </SidePanel>
        </div>
      </>
    );
  }
}

export default withRouter(CTViewer);

/**
 * What types are these? Why do we have "mapping" dropped in here instead of in
 * a mapping layer?
 *
 * TODO[react]:
 * - Add sorting of display sets
 * - Add showStackLoadingProgressBar option
 *
 * @param {Study[]} studies
 * @param {DisplaySet[]} studies[].displaySets
 */
const _mapStudiesToThumbnails = function(studies) {
  return studies.map(study => {
    const { studyInstanceUid } = study;

    const thumbnails = study.displaySets.map((displaySet = {}) => {
      const { displaySetInstanceUid, seriesDescription } = displaySet;
      const { instanceNumber, numImageFrames, seriesNumber } = displaySet;
      let imageId, altImageText;
      if (displaySet.modality && displaySet.modality === 'SEG') {
        altImageText = 'SEG';
      } else if (displaySet.images && displaySet.images.length) {
        const imageIndex = Math.floor(displaySet.images.length / 2);
        imageId = displaySet.images[imageIndex].getImageId();
      } else {
        altImageText = displaySet.modality ? displaySet.modality : 'UN';
      }

      return {
        imageId,
        altImageText,
        displaySetInstanceUid,
        seriesDescription,
        seriesNumber,
        instanceNumber,
        numImageFrames,
      };
    });

    return { studyInstanceUid, thumbnails };
  });
};
